module.exports = __webpack_public_path__ + "static/media/bbb-chip-tournament.7685b6ad.png";